<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Translation message</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="alert alert-warning" role="alert">
    Line {{ line }}, column {{ column }} : {{ error }}
  </div>
  <textarea [(ngModel)]="text" class="form-control" rows="20" (click)="updatePosition($event)"
            (keyup)="updatePosition($event)"></textarea>
  <div>
    @if (position) {
      Line {{ position?.line }}, column {{ position?.column }}
    }
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
  <button form="form" type="button" class="btn btn-primary fw-bold" (click)="submit()">Update</button>
</div>
